import { RightOutlined } from "@ant-design/icons";

type MobileNavRowProps = {
  title: string;
  onClick: () => void;
};

export function MobileNavRow({ title, onClick }: MobileNavRowProps) {
  // 单行导航（直接跳转）
  return (
    <button
      type="button"
      className="flex w-full items-center justify-between border-b border-yoyo-border/60 px-4 py-4 last:border-b-0"
      onClick={onClick}
    >
      <span className="text-[20px] font-bold text-yoyo-text">{title}</span>
      <RightOutlined className="text-xs text-yoyo-secondary/70" />
    </button>
  );
}
